import { render, staticRenderFns } from "./Checklists.vue?vue&type=template&id=2cc368fb&scoped=true"
import script from "./Checklists.vue?vue&type=script&lang=js"
export * from "./Checklists.vue?vue&type=script&lang=js"
import style0 from "./Checklists.vue?vue&type=style&index=0&id=2cc368fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc368fb",
  null
  
)

export default component.exports